import { render, staticRenderFns } from "./RuleUseAddModal.vue?vue&type=template&id=5f6cbbd1&scoped=true"
import script from "./RuleUseAddModal.vue?vue&type=script&lang=js"
export * from "./RuleUseAddModal.vue?vue&type=script&lang=js"
import style0 from "./RuleUseAddModal.vue?vue&type=style&index=0&id=5f6cbbd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6cbbd1",
  null
  
)

export default component.exports